<script lang="ts">
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import Flash from "@shared/services/flashv2";

  export let showModal;
  export let newListName;

  let isSubmitting: boolean = false;

  const closeModal = () => {
    showModal = false;
  };

  const createList = () => {
    isSubmitting = true;

    HttpPromise({
      method: "POST",
      url: "/api/retailer/quick_order_lists/",
      data: {
        name: newListName,
      },
    }).then(
      function (res) {
        window["stateService"].go("layout.list_details", {
          listId: res.id,
        });
        closeModal();
        newListName = "";
        isSubmitting = false;
      },
      function (res) {
        isSubmitting = false;
        res?.errors?.messages?.forEach((message: string) => {
          Flash.now({ type: "error", message });
        });
      }
    );
  };

</script>

<Modal bind:show={showModal} fizzModal={true} size="small" closeOnBackgroundClick={false}>
  <div class="layout-header-footer">
    <header class="fizz-modal-header fizz-space-between">
      <h4 class="fizz-heading-3">Create a new list</h4>
      <div class="fizz-modal-toggle fizz-modal-close" on:click|preventDefault={closeModal}>
        <Icon type="X" extraClassNames="fizz-text-brand cursor-pointer" height="16" width="16" />
      </div>
    </header>

    <section class="fizz-modal-main fizz-text-medium fizz-flow-16">
      <label class="fizz-label fizz-stack-4" for="list-name-input">List name</label>
      <!-- svelte-ignore a11y-autofocus -->
      <input
        type="text"
        id="list-name-input"
        class="fizz-input-text fizz-full-width"
        bind:value={newListName}
        autofocus
      />
    </section>

    <section class="fizz-modal-footer fizz-flex-row fizz-justify-end">
      <button class="fizz-button" on:click|preventDefault={closeModal}>Cancel</button>
      <button
        class="fizz-button-secondary"
        disabled={!newListName.trim() || isSubmitting}
        on:click|preventDefault={createList}>Create</button
      >
    </section>
  </div>
</Modal>
